module.exports = __webpack_public_path__ + "static/media/redes_icons_Mesa de trabajo 1.fcc4eed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/redes_icons_Mesa de trabajo 1.png
// module id = 149
// module chunks = 0